export const pageTransitionDuration = 0.3;
